import type {
  CollectionCard,
  CollectionFacetFilters,
  CollectionFacetCountsResponse,
  FacetCountsResponse,
  SortOrderEnum,
} from "modules/collections/details/model/collection";
import type {
  ItemSortOptionsEnum,
  TradeItem,
  TradeListItemModel,
} from "modules/tradeLists/model/tradeList";

export const BINDER_SECTIONS = ["haves", "wants", "collection"] as const;
export type BinderSection = (typeof BINDER_SECTIONS)[number];

export interface BinderItemsRequest {
  collectionId: string;
  section: BinderSection;
  listId?: string;
  page: number;
  perPage: number;
  query: string;
  sort: ItemSortOptionsEnum;
  order: SortOrderEnum;
  facets: CollectionFacetFilters;
}

export type BinderItem =
  | { kind: "collection"; card: CollectionCard }
  | { kind: "list"; item: TradeItem };

export interface BinderItemsPage {
  items: BinderItem[];
  hasMore: boolean;
}

export interface BinderPageInitialData {
  collectionId: string;
  userId: string;
  lists: TradeListItemModel[];
  collectionStats: CollectionFacetCountsResponse;
  initialRequest: BinderItemsRequest;
  initialPage: BinderItemsPage;
  initialFacets: FacetCountsResponse;
}
